import React from "react";

const CategoryItems = ({ items, title, data }) => {
  let categories = Object.keys(data);
  let currentCategoryIndex = categories.indexOf(title);
  let totalCategories = Object.keys(data).length;
  return (
    <div className="category-items__container">
      <div className="category-items__heading">
        <h2 className="category-items__title">{title}</h2>
        <div className="category-items__index">
          {currentCategoryIndex + 1}/{totalCategories}
        </div>
      </div>
      <div className="category-items__content">
        {items.map((item, index) => (
          <div className="category-items__item" key={index}>
            <div className="category-items__image-container">
              <img
                src={item.imageUrl}
                alt="image"
                className="category-items__image"
              />
            </div>
            <div className="category-items__item-details">
              <div className="category-items__item-name">{item.itemName}</div>
              <div className="category-items__item-price">{item.price}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryItems;
